module.exports = __webpack_public_path__ + "img/BChariotArcher64_ua.1ee02716.webp";